
/*
  FRADIME PRODUCT SIZE CALCULATOR
  V3.3 - STABLE REPLACEMENT

  Required assets:
  - fradime-size-guide-data.js
  - fradime-size-engine.js

  Features:
  - Product-specific garment matching
  - Inches and centimetres
  - Available Shopify sizes only
  - Collapsible product-page interface
  - Isolated from Shopify's variant form
  - Safe reinitialisation after theme updates

  Does not change selected Shopify variants.
*/

(function () {
  "use strict";

  var STYLE_ID = "fradime-product-size-calculator-styles";
  var SELECTOR = "[data-fradime-size-calculator]";
  var observer = null;
  var initScheduled = false;
  var instanceCounter = 0;

  function escapeHTML(value) {
    return String(value == null ? "" : value).replace(
      /[&<>"']/g,
      function (character) {
        return {
          "&": "&amp;",
          "<": "&lt;",
          ">": "&gt;",
          '"': "&quot;",
          "'": "&#39;"
        }[character];
      }
    );
  }

  function formatNumber(value) {
    return (Math.round(value * 10) / 10).toFixed(1);
  }

  function addStyles() {
    if (document.getElementById(STYLE_ID)) {
      return;
    }

    var style = document.createElement("style");
    style.id = STYLE_ID;

    style.textContent = `
      /* MAIN WIDGET */

      .fradime-product-size-calculator {
        display: block;
        box-sizing: border-box;
        width: 100%;
        min-width: 0;
        margin: 12px 0 8px;
        border: 1px solid #dedede;
        border-radius: 6px;
        background: transparent;
        color: inherit;
        text-align: left;
        overflow: hidden;
      }

      .fradime-product-size-calculator[hidden],
      .fradime-product-size-calculator[data-fsg-pending] {
        display: none !important;
      }

      /* COLLAPSED TRIGGER */

      .fradime-size-calculator-trigger {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 12px;
        width: 100%;
        padding: 14px;
        margin: 0;
        cursor: pointer;
        list-style: none;
        font-size: 13px;
        font-weight: 600;
        line-height: 1.45;
        text-align: left;
      }

      .fradime-size-calculator-trigger::-webkit-details-marker {
        display: none;
      }

      .fradime-size-calculator-trigger::marker {
        content: "";
      }

      .fradime-size-calculator-trigger:focus-visible {
        outline: 2px solid currentColor;
        outline-offset: -4px;
      }

      .fradime-size-calculator-trigger-text {
        flex: 1;
        min-width: 0;
      }

      .fradime-size-calculator-chevron {
        flex: 0 0 auto;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        width: 20px;
        height: 20px;
        font-size: 20px;
        font-weight: 400;
        line-height: 1;
        transition: transform 0.2s ease;
      }

      .fradime-product-size-calculator[open]
      .fradime-size-calculator-chevron {
        transform: rotate(45deg);
      }

      /* EXPANDED CONTENT */

      .fradime-size-calculator-content {
        display: block;
        padding: 16px 14px;
        border-top: 1px solid #e5e5e5;
      }

      .fradime-size-calculator-intro {
        margin: 0 0 14px;
        font-size: 13px;
        line-height: 1.65;
      }

      /* UNITS */

      .fradime-size-calculator-units {
        display: flex;
        flex-wrap: wrap;
        gap: 7px;
        margin: 0 0 16px;
      }

      .fradime-size-calculator-units button {
        appearance: none;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        min-height: 40px;
        padding: 9px 17px;
        margin: 0;
        border: 1px solid #d8d8d8;
        border-radius: 5px;
        background: #fff;
        color: #111;
        font-family: inherit;
        font-size: 12px;
        font-weight: 500;
        line-height: 1.2;
        cursor: pointer;
      }

      .fradime-size-calculator-units
      button[aria-pressed="true"] {
        background: #111;
        color: #fff;
        border-color: #111;
      }

      /* MEASUREMENT METHOD */

      .fradime-size-calculator-methods {
        display: grid;
        grid-template-columns: repeat(2, minmax(0, 1fr));
        gap: 8px;
        margin: 0 0 16px;
      }

      .fradime-size-calculator-method {
        display: flex;
        align-items: flex-start;
        gap: 9px;
        min-width: 0;
        padding: 12px;
        margin: 0;
        border: 1px solid #ddd;
        border-radius: 6px;
        background: #fff;
        color: #111;
        font-size: 12px;
        font-weight: 500;
        line-height: 1.5;
        text-align: left;
        cursor: pointer;
      }

      .fradime-size-calculator-method:has(input:checked) {
        border-color: #111;
      }

      .fradime-size-calculator-method input {
        appearance: auto;
        display: block;
        position: static;
        width: 15px;
        height: 15px;
        min-width: 15px;
        flex: 0 0 15px;
        margin: 2px 0 0;
        padding: 0;
        opacity: 1;
        accent-color: #111;
        cursor: pointer;
      }

      .fradime-size-calculator-method span {
        display: block;
        flex: 1;
        min-width: 0;
      }

      /* MEASUREMENT INPUTS */

      .fradime-size-calculator-fields-grid {
        display: grid;
        grid-template-columns: repeat(2, minmax(0, 1fr));
        gap: 12px;
        margin-top: 12px;
      }

      .fradime-size-calculator-field {
        min-width: 0;
      }

      .fradime-size-calculator-field label {
        display: block;
        width: 100%;
        margin: 0 0 8px;
        font-size: 12px;
        font-weight: 600;
        line-height: 1.45;
      }

      .fradime-size-calculator-field input {
        box-sizing: border-box;
        display: block;
        width: 100%;
        min-width: 0;
        min-height: 44px;
        padding: 10px 12px;
        margin: 0;
        border: 1px solid #ccc;
        border-radius: 5px;
        background: #fff;
        color: #111;
        font-family: inherit;
        font-size: 14px;
        line-height: 1.4;
        box-shadow: none;
      }

      .fradime-size-calculator-field input:focus {
        outline: 1px solid #111;
        outline-offset: 0;
        border-color: #111;
      }

      /* SUBMIT BUTTON */

      .fradime-size-calculator-submit {
        appearance: none;
        display: block;
        width: 100%;
        min-height: 46px;
        margin: 16px 0 0;
        padding: 12px 15px;
        border: 1px solid #111;
        border-radius: 5px;
        background: #111;
        color: #fff;
        font-family: inherit;
        font-size: 13px;
        font-weight: 700;
        line-height: 1.3;
        text-align: center;
        cursor: pointer;
      }

      .fradime-size-calculator-submit:hover {
        background: #333;
      }

      /* RESULTS */

      .fradime-size-calculator-result {
        display: block;
      }

      .fradime-size-calculator-result:empty {
        display: none;
      }

      .fradime-size-calculator-result:not(:empty) {
        margin-top: 15px;
        padding: 14px;
        border: 1px solid #dedede;
        border-radius: 6px;
        background: #fafafa;
        color: #111;
        font-size: 12px;
        line-height: 1.65;
      }

      .fradime-size-calculator-result strong {
        font-weight: 700;
      }

      .fradime-size-calculator-result p {
        margin: 7px 0;
        font-size: inherit;
        line-height: inherit;
      }

      .fradime-size-calculator-result-size {
        display: block;
        margin: 5px 0;
        font-size: 30px;
        font-weight: 800;
        line-height: 1.2;
      }

      .fradime-size-calculator-full-link {
        display: inline-block;
        margin-top: 16px;
        font-size: 12px;
        font-weight: 500;
        color: inherit;
        text-decoration: underline;
        text-underline-offset: 3px;
      }

      /* MOBILE */

      @media (max-width: 420px) {
        .fradime-size-calculator-methods,
        .fradime-size-calculator-fields-grid {
          grid-template-columns: 1fr;
        }

        .fradime-size-calculator-content {
          padding: 14px 12px;
        }
      }

      @media (prefers-reduced-motion: reduce) {
        .fradime-size-calculator-chevron {
          transition: none;
        }
      }
    `;

    document.head.appendChild(style);
  }

  /*
    FIND THE VARIANT PICKER ASSOCIATED WITH
    A PARTICULAR CALCULATOR.

    The calculator will later be moved outside
    the variant-picker form.
  */

  function getPicker(widget) {
    if (widget._fradimePicker &&
        widget._fradimePicker.isConnected) {
      return widget._fradimePicker;
    }

    var picker = widget.closest("variant-picker");

    if (picker) {
      widget._fradimePicker = picker;
    }

    return picker;
  }

  /*
    MOVE CALCULATOR OUTSIDE SHOPIFY'S
    VARIANT PICKER.

    It will remain immediately after the picker,
    which is directly beneath the size buttons
    for this theme.

    This prevents typing and method changes
    from bubbling through the variant form.
  */

  function isolateWidget(widget) {
    var picker = getPicker(widget);

    if (!picker || !picker.parentNode) {
      return false;
    }

    if (widget.previousElementSibling === picker &&
        widget.parentNode === picker.parentNode) {
      return true;
    }

    picker.insertAdjacentElement("afterend", widget);

    return true;
  }

  /*
    GET AVAILABLE SHOPIFY SIZE OPTIONS.

    Uses the original size picker, even after
    the calculator has been moved outside it.
  */

  function getAvailableSizes(widget) {
    var picker = getPicker(widget);

    if (!picker) {
      return [];
    }

    var fieldset = picker.querySelector(
      "fieldset.fradime-size-picker"
    );

    if (!fieldset) {
      return [];
    }

    return Array.from(
      fieldset.querySelectorAll('input[type="radio"]')
    ).filter(function (input) {
      return input.dataset.optionAvailable === "true" &&
        input.getAttribute("aria-disabled") !== "true";
    }).map(function (input) {
      return String(input.value).trim();
    });
  }

  function initWidget(widget) {
    if (widget.dataset.fsgReady === "true") {
      return;
    }

    var engine = window.FRADIME_SIZE_ENGINE;

    if (!engine || !window.FRADIME_SIZE_DATA) {
      return;
    }

    var productKey = widget.getAttribute(
      "data-fradime-product-key"
    );

    if (!productKey) {
      return;
    }

    var product = engine.findProduct(productKey);

    if (!product) {
      return;
    }

    var pair = engine.getPair(product);

    if (!pair || pair.length !== 2) {
      return;
    }

    var available = getAvailableSizes(widget);

    if (!engine.eligibleSizes(product, available).length) {
      return;
    }

    var fields = widget.querySelector(
      ".fradime-size-calculator-fields"
    );

    var result = widget.querySelector(
      ".fradime-size-calculator-result"
    );

    var unitButtons = Array.from(
      widget.querySelectorAll("[data-fsg-unit]")
    );

    if (!fields || !result || unitButtons.length !== 2) {
      return;
    }

    /*
      Move the existing element. We don't clone it,
      so its state and event listeners remain intact.
    */

    if (!isolateWidget(widget)) {
      return;
    }

    instanceCounter += 1;

    var instanceId = "fradime-size-" + instanceCounter;

    var state = {
      unit: "in",
      method: "garment"
    };

    function renderMethods() {
      return `
        <div class="fradime-size-calculator-methods">
          <label class="fradime-size-calculator-method">
            <input
              type="radio"
              name="${instanceId}-method"
              value="garment"
              data-fsg-method
              ${state.method === "garment" ? "checked" : ""}
            >
            <span>Measure a garment I own</span>
          </label>

          <label class="fradime-size-calculator-method">
            <input
              type="radio"
              name="${instanceId}-method"
              value="body"
              data-fsg-method
              ${state.method === "body" ? "checked" : ""}
            >
            <span>Use my body measurements</span>
          </label>
        </div>
      `;
    }

    function renderFields() {
      result.innerHTML = "";

      if (state.method === "body") {
        fields.innerHTML = renderMethods() + `
          <p class="fradime-size-calculator-intro">
            Body-measurement recommendations are not
            yet calibrated for this product.
            For now, measure a garment you own
            or refer to the full size guide.
          </p>
        `;

        return;
      }

      var unitLabel = state.unit === "cm"
        ? "cm"
        : "inches";

      var inputsHTML = pair.map(function (row, index) {
        var id = instanceId + "-input-" + index;

        return `
          <div class="fradime-size-calculator-field">
            <label for="${id}">
              ${escapeHTML(row.label)}
              (${unitLabel})
            </label>

            <input
              id="${id}"
              type="number"
              inputmode="decimal"
              min="0.1"
              max="400"
              step="any"
              data-fsg-input="${index}"
              placeholder="Enter measurement"
            >
          </div>
        `;
      }).join("");

      fields.innerHTML = renderMethods() + `
        <p class="fradime-size-calculator-intro">
          Lay a similar garment flat without
          stretching it. Enter both measurements
          below to compare its dimensions.
        </p>

        <div class="fradime-size-calculator-fields-grid">
          ${inputsHTML}
        </div>

        <button
          type="button"
          class="fradime-size-calculator-submit"
          data-fsg-submit
        >
          Find My Closest Size
        </button>
      `;
    }

    function calculate() {
      result.innerHTML = "";

      var firstInput = fields.querySelector(
        '[data-fsg-input="0"]'
      );

      var secondInput = fields.querySelector(
        '[data-fsg-input="1"]'
      );

      if (!firstInput || !secondInput ||
          firstInput.value.trim() === "" ||
          secondInput.value.trim() === "") {
        result.textContent =
          "Please enter both measurements.";
        return;
      }

      var first = Number(firstInput.value);
      var second = Number(secondInput.value);

      if (!Number.isFinite(first) ||
          !Number.isFinite(second) ||
          first <= 0 ||
          second <= 0 ||
          first > 400 ||
          second > 400) {
        result.textContent =
          "Please enter valid positive measurements.";
        return;
      }

      var measurements = [
        engine.toInches(first, state.unit),
        engine.toInches(second, state.unit)
      ];

      /*
        Recheck currently available sizes.
        Do not change Shopify's selected variant.
      */

      var availableSizes = getAvailableSizes(widget);

      var outcome = engine.compare(
        product,
        measurements,
        availableSizes
      );

      if (!outcome || !outcome.best) {
        result.textContent =
          "No suitable size data is currently available.";
        return;
      }

      var best = outcome.best;

      var firstTarget = formatNumber(
        engine.fromInches(best.target1, state.unit)
      );

      var secondTarget = formatNumber(
        engine.fromInches(best.target2, state.unit)
      );

      var unitName = state.unit === "cm"
        ? "cm"
        : "inches";

      
      function describeDifference(target, entered) {
        var difference = target - entered;
        var tolerance = state.unit === "cm" ? 0.0254 : 0.01;

        if (Math.abs(difference) < tolerance) {
          return "Same measurement";
        }

        return (
          formatNumber(Math.abs(difference)) +
          (state.unit === "cm" ? " cm " : '" ') +
          (difference > 0 ? "wider/longer" : "narrower/shorter")
        );
      }

      var widthDifference = best.target1 - measurements[0];
      var lengthDifference = best.target2 - measurements[1];

      function differenceText(difference, dimension) {
        var absolute = Math.abs(difference);

        if (absolute < 0.01) {
          return "Same measurement";
        }

        var displayValue = formatNumber(
          engine.fromInches(absolute, state.unit)
        );

        var direction;

        if (dimension === "width") {
          direction = difference > 0 ? "wider" : "narrower";
        } else {
          direction = difference > 0 ? "longer" : "shorter";
        }

        return displayValue + " " + unitName + " " + direction;
      }

      var widthExplanation = differenceText(
        widthDifference,
        "width"
      );

      var lengthExplanation = differenceText(
        lengthDifference,
        "length"
      );

      var sizeHeading = outcome.poorMatch
        ? "No close garment match"
        : "Your closest garment match";

      var sizeIntro = outcome.poorMatch
        ? "This is the nearest available size mathematically, but its measurements differ significantly from your reference garment."
        : "This is the closest overall match to the garment you measured.";

      var fitExplanation = outcome.poorMatch
        ? "The dimensions are not close enough for us to suggest this as a similar fit. Check the full size chart before choosing."
        : "If you want a similar fit to your current garment, this is the closest measured option. Check the differences above to decide whether you are happy with it being slightly wider, narrower, longer or shorter.";

      
      result.innerHTML = `
        <strong>${sizeHeading}</strong>

        <span class="fradime-size-calculator-result-size">
          ${escapeHTML(best.size)}
        </span>

        <p>${sizeIntro}</p>

        <details style="
          margin: 14px 0;
          border: 1px solid #dedede;
          border-radius: 6px;
          overflow: hidden;
        ">

          <summary style="
            display: flex;
            justify-content: space-between;
            align-items: center;
            gap: 10px;
            padding: 13px 12px;
            cursor: pointer;
            font-size: 12px;
            font-weight: 700;
            line-height: 1.5;
          ">
            <span>How it compares to your garment</span>
            <span aria-hidden="true">+</span>
          </summary>

          <div style="
            padding: 12px;
            border-top: 1px solid #dedede;
            display: grid;
            gap: 13px;
          ">

            <div>
              <strong>${escapeHTML(pair[0].label)}</strong>

              <p>
                Your garment:
                ${formatNumber(engine.fromInches(
                  measurements[0],
                  state.unit
                ))} ${unitName}
              </p>

              <p>
                FRADIMÉ:
                ${firstTarget} ${unitName}
              </p>

              <p>
                <strong>Difference:</strong>
                ${widthExplanation}
              </p>
            </div>

            <div>
              <strong>${escapeHTML(pair[1].label)}</strong>

              <p>
                Your garment:
                ${formatNumber(engine.fromInches(
                  measurements[1],
                  state.unit
                ))} ${unitName}
              </p>

              <p>
                FRADIMÉ:
                ${secondTarget} ${unitName}
              </p>

              <p>
                <strong>Difference:</strong>
                ${lengthExplanation}
              </p>
            </div>

          </div>

        </details>

        <div style="
          padding: 12px;
          background: #f1f1f1;
          border-radius: 5px;
        ">
          <strong>What this means</strong>

          <p style="margin-bottom: 0;">
            ${fitExplanation}
          </p>
        </div>

        <p style="margin-top: 12px;">
          This compares garment measurements,
          not body measurements. Fit can also vary
          with fabric, stretch and garment construction.
        </p>
      `;


    }

    /*
      EVENT DELEGATION

      One listener on the isolated widget,
      rather than repeatedly binding listeners
      to inputs as the interface is updated.
    */

    widget.addEventListener("change", function (event) {
      var method = event.target.closest(
        "[data-fsg-method]"
      );

      if (!method) {
        return;
      }

      state.method = method.value;
      renderFields();
    });

    widget.addEventListener("click", function (event) {
      var unitButton = event.target.closest(
        "[data-fsg-unit]"
      );

      if (unitButton && widget.contains(unitButton)) {
        event.preventDefault();

        var newUnit = unitButton.dataset.fsgUnit;

        if (newUnit !== "in" && newUnit !== "cm") {
          return;
        }

        if (newUnit === state.unit) {
          return;
        }

        state.unit = newUnit;

        unitButtons.forEach(function (button) {
          button.setAttribute(
            "aria-pressed",
            String(button.dataset.fsgUnit === state.unit)
          );
        });

        renderFields();
        return;
      }

      var submit = event.target.closest(
        "[data-fsg-submit]"
      );

      if (submit && widget.contains(submit)) {
        event.preventDefault();
        calculate();
      }
    });

    /*
      The widget is ready.

      Support either version of the Liquid snippet:
      - Original "hidden"
      - Newer "data-fsg-pending"
    */

    renderFields();

    widget.dataset.fsgReady = "true";
    widget.removeAttribute("data-fsg-pending");
    widget.hidden = false;
  }

  function init() {
    if (!window.FRADIME_SIZE_ENGINE ||
        !window.FRADIME_SIZE_DATA) {
      return;
    }

    var widgets = document.querySelectorAll(SELECTOR);

    if (!widgets.length) {
      return;
    }

    addStyles();

    widgets.forEach(initWidget);
  }

  /*
    Watch only for new calculator elements.

    Existing calculators are not rebuilt while
    customers are typing or switching methods.
  */

  function scheduleInit() {
    if (initScheduled) {
      return;
    }

    initScheduled = true;

    requestAnimationFrame(function () {
      initScheduled = false;
      init();
    });
  }

  function watchPage() {
    if (observer || !document.body) {
      return;
    }

    observer = new MutationObserver(function (mutations) {
      var foundNewWidget = false;

      for (var i = 0; i < mutations.length; i++) {
        var mutation = mutations[i];

        if (mutation.type !== "childList") {
          continue;
        }

        for (var j = 0; j < mutation.addedNodes.length; j++) {
          var node = mutation.addedNodes[j];

          if (node.nodeType !== 1) {
            continue;
          }

          if (
            node.matches &&
            node.matches(SELECTOR)
          ) {
            foundNewWidget = true;
            break;
          }

          if (
            node.querySelector &&
            node.querySelector(SELECTOR)
          ) {
            foundNewWidget = true;
            break;
          }
        }

        if (foundNewWidget) {
          break;
        }
      }

      if (foundNewWidget) {
        scheduleInit();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  function start() {
    init();
    watchPage();
  }

  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      start,
      { once: true }
    );
  } else {
    start();
  }

  document.addEventListener(
    "shopify:section:load",
    scheduleInit
  );

  window.addEventListener(
    "pageshow",
    scheduleInit
  );

})();
